import { render, staticRenderFns } from "./UserFamilyItemChild.vue?vue&type=template&id=6e05387a&scoped=true&"
import script from "./UserFamilyItemChild.vue?vue&type=script&lang=js&"
export * from "./UserFamilyItemChild.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyItemChild.vue?vue&type=style&index=0&id=6e05387a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05387a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e05387a')) {
      api.createRecord('6e05387a', component.options)
    } else {
      api.reload('6e05387a', component.options)
    }
    module.hot.accept("./UserFamilyItemChild.vue?vue&type=template&id=6e05387a&scoped=true&", function () {
      api.rerender('6e05387a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFamilyItemChild.vue"
export default component.exports